import { GetAllCasinoGameCategoryResponse } from '../../CRM/Responses/CasinoGameCategoryResponse';
import { GetAllCasinoGameCategoryBlockResponse } from '../../CRM/Responses/GetAllCasinoGameCategoryBlockResponse';

import AbstractCasinoSiteApi from 'casino/Api/AbstractCasinoSiteApi';
import GetCasinoGameResponse from 'casino/Api/CRM/Responses/CasinoGameResponse';
import {
    API_CASINO_GAME_BLOCKS,
    API_CASINO_GAME_CATEGORIES,
    API_CASINO_GAMES_LIMITED,
} from 'crm/casino/pages/Helpers/SiteApiUrls';

class CasinoGameApi extends AbstractCasinoSiteApi {
    public async getLimited(limit: number, casinoGameCategoryTranslationId: number): Promise<GetCasinoGameResponse[]> {
        return (
            await this.get(API_CASINO_GAMES_LIMITED, {
                params: { limit, casino_game_category_translation_id: casinoGameCategoryTranslationId },
            })
        ).data;
    }

    public async getGameCategories(): Promise<GetAllCasinoGameCategoryResponse> {
        return (await this.get(API_CASINO_GAME_CATEGORIES)).data;
    }

    public async getGameBlocks(): Promise<GetAllCasinoGameCategoryBlockResponse> {
        return (await this.get(API_CASINO_GAME_BLOCKS)).data;
    }
}

export default new CasinoGameApi();
